import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Terms() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background text-text relative">
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-32">
        <button 
          onClick={() => navigate('/')}
          className="flex items-center text-gray-400 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </button>

        <h1 className="text-4xl font-bold mb-8 heading-gradient">Terms of Service</h1>
        
        <div className="prose prose-invert max-w-none">
          <div className="text-gray-300 mb-8">
            Welcome to Perplexity, "Perplexity Meet", "Reports Detective", "Perplexity 180" "Perplexity ALM" other products and services are owned by Perplexity.
            <div className="flex items-center gap-4 my-4">
              <img src="https://raw.githubusercontent.com/stackblitz/stackblitz-upload-service/master/logo.png" alt="Perplexity" className="h-12 w-auto" />
              <span>is a registered trademark owned by: Perplexity Solved Solutions Inc.</span>
            </div>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">1. Definitions</h2>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>"Reports Detective" refers to our BI data analytics and AI, reporting platform.</li>
              <li>"Perplexity Meet" refers to our video conferencing, team collaboration platform.</li>
              <li>"Service" refers to the Reports Detective, Perplexity Meet and all other platforms and related services.</li>
              <li>"User" refers to any individual or entity using our Service.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">2. Use of Service</h2>
            <p className="text-gray-300 mb-4">
              Reports Detective is a data analytics and reporting platform designed for business intelligence. Users must comply with all applicable laws and our acceptable use policies.
            </p>
            <p className="text-gray-300">
              Perplexity Meet is a low-cost video conferencing and scheduling platform option designed for instructors, small team and business.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">3. Account Terms</h2>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>Reports Detective: You must be 18 years or older to use this Service</li>
              <li>Perplexity Meet: You must 16 or older to use this Service unless supervised by a school or private educator.</li>
              <li>You must provide accurate and complete registration information</li>
              <li>You are responsible for maintaining the security of your account and password and networks used to access our platforms</li>
              <li>You are responsible for all activities under your account</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">4. Payment Terms</h2>
            <p className="text-gray-300">
              Some features of all products require paid subscriptions. Payment terms are based on your selected plan. All payments are processed securely through our payment providers.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">5. Data Usage</h2>
            <p className="text-gray-300 mb-4">
              We handle all data in accordance with our Privacy Policy and applicable data protection laws. Users retain all rights to their data processed through our Service.
            </p>
            <p className="text-gray-300">
              If you want to request that any free trial data or newsletter data from sign-ups or contact forms are deleted, to opt-out. Please send a detailed request to legal@perplexityonline.com
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">6. Intellectual Property</h2>
            <p className="text-gray-300">
              Perplexity & Reports Detective are trademarks of Perplexity Solved Solutions Inc. All rights reserved. Users may not copy, modify, or distribute our Trademark name or any platforms or products without explicit permission. Any form of automated data collection, including but not limited to data scraping, web scraping, web harvesting, or web data extraction from our platforms and services is strictly prohibited without prior written authorization.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">7. Termination</h2>
            <p className="text-gray-300">
              We reserve the right to suspend or terminate accounts that violate these terms or engage in unauthorized use of our Service. We reserve the right to end or change any free trials or promotion during anytime without written notification.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">8. Contact Information</h2>
            <div className="text-gray-300">
              <p>Perplexity</p>
              <p>5851 Legacy Cir</p>
              <p>Plano, Texas 75024</p>
              <p>United States</p>
              <p className="mt-4">General questions: info@perplexityonline.com</p>
            </div>
          </section>

          <div className="text-gray-400 mt-12 text-sm">
            These Terms of Service were created in March 2021 and last updated in February 2025. By using our platforms and or service, you acknowledge that you have read and agree to these terms.
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}